const colors = {
  gray: {
    10: '#FCFCFC',
    25: '#F5F9FA',
    850: '#151A23',
  },
  teal: {
    100: '#EAF8F9',
    150: '#D4F5F7',
    500: '#2EB5C0',
  },
  red: {
    450: '#F26157',
  },
  green: {
    250: '#7FB069',
  },
  primary: {
    tealGradient: 'linear-gradient(to right, #44c7b9, #21e3cc)',
    tealGradientHover: 'linear-gradient(to right, #62d0c5, #45e8d5)',
    tealGreenGradient: 'linear-gradient(265.59deg, #0BE2F7 0%, #85D486 100%)',
  },
};

export { colors };
